import * as React from 'react';
import AssetsManager from '../../utils/AssetsManager';
import {GLOBAL} from '../../../pay-warranty/constants/LabelConstants';
import Button from '../Button';
import {ApplicantInformationProps} from '../../../wizard/types/mx/creditoReal/components';

class AssistantInformationView extends React.Component<ApplicantInformationProps, {}> {

    render() {
        const {onPressClose, assistantInformation} = this.props;
        const assistant = assistantInformation.assistantMxes[0];
        return (
            <div className="modal-info">
                <div className="wrapper-assistant py-3">
                    <div className="assistant d-flex align-items-center justify-content-center mb-3">
                        <div className="img-assistant">
                            <div className="budge-assistant">
                                <img className="img-fluid" alt="alerta"
                                     src={AssetsManager(
                                         '/assets/images/common/assistant-badge.svg'
                                     )}/>
                            </div>
                            <img src={assistant.assistantUrl} alt={assistant.assistantNameText}
                                 className="img-fluid"/>
                        </div>
                    </div>
                    <div className="details-assistant text-center mb-4">
                        <h5 className="mb-2">{assistant.assistantNameText}</h5>
                        <p>{assistant.assistantChargeText}</p>
                    </div>
                    <div className="content-assistant mb-5">
                        <h4>{assistantInformation.title}</h4>
                        <span dangerouslySetInnerHTML={{__html: assistantInformation.descriptionHtml}}/>
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                        <Button text={GLOBAL.AGREED} onPress={() => onPressClose()}
                                role="button"
                                customClass="px-md-5 text-uppercase h6" type="link"/>
                    </div>
                </div>
            </div>
        );
    }
}

export default AssistantInformationView;